import { useLang } from "hooks/useLang"
import { useEffect, useState } from "react"
import { CopyToClipboard } from "react-copy-to-clipboard"
import Image from "next/image"
import CloseIcon from "components/icons/CloseIcon"

const ShareComponent = ({
    link,
    event_name,
    event_poster,
    setIsShareComponentOpen
}: { link: string; event_name: string; event_poster: string, setIsShareComponentOpen: (val: boolean) => void }) => {
    const [copied, setCopied] = useState(false)

    const handleWhatsAppShare = () => {
        const whatsappUrl = `https://api.whatsapp.com/send?text=${encodeURIComponent(link)}`
        window.open(whatsappUrl, "_blank")
    }

    const handleXShare = () => {
        const twitterShareUrl = `https://twitter.com/intent/tweet?text=${encodeURIComponent(`${event_name}`)}&url=${encodeURIComponent(link)}`
        window.open(twitterShareUrl, "_blank", "noopener,noreferrer")
    }

    const { t } = useLang()

    useEffect(() => {
        if (copied) {
            const timeout = setTimeout(() => setCopied(false), 4000)
            return () => clearTimeout(timeout) // Cleanup the timeout if `copied` changes
        }
    }, [copied])




    return (
        <div className="bg-white  md:relative  rounded-lg shadow-lg sm:w-full md:min-w-[600px] left-0 right-0  bottom-0 md:left-auto md:right-0  md:bottom-auto py-2  text-center rounded-t-[20px] md:rounded-[20px] justify-center flex px-4 animate-slideUp md:animate-none ">
            {/* <div className="bg-white  md:relative  rounded-lg shadow-lg sm:w-full md:min-w-[600px] left-0 right-0  bottom-0 md:left-auto md:right-0  md:bottom-auto py-2  text-center rounded-t-[20px] md:rounded-[20px] justify-center flex px-4 animate-slideUp md:animate-none"> */}
            <div className="flex flex-col w-full h-full items-center">
                <div className="bg-[#000000] w-[10%] h-[4px] mb-2 rounded-[3px] block md:hidden"></div>

                <div className="w-full h-full flex flex-col p-2 px-0 gap-4">
                    <div onClick={() => setIsShareComponentOpen(false)} className="md:flex w-full justify-end cursor-pointer">
                        <CloseIcon color="black" />
                    </div>
                    <div className="flex flex-1  bg-[#fff] w-full min-h-[250px] ">
                        <div className=" flex-1 w-full relative">
                            <Image
                                fill
                                style={{ objectFit: "cover" }}
                                src={`${process.env.NEXT_PUBLIC_Event_Img_URL}${event_poster}`}
                                alt={event_name}
                                className="rounded-[20px] bg-cover bg-center"
                                quality="100"
                            />

                            <div
                                style={{ zIndex: 20 }}
                                className="absolute  bottom-10 px-4 text-[24px] text-[#fff] font-[700] self-start w-full text-left capitalize"
                            >
                                {event_name}
                            </div>
                        </div>
                    </div>
                    <div className="flex flex-1  bg-[#fff] justify-center items-center w-full  md:py-0">
                        <CopyToClipboard
                            className="cursor-pointer text-[#000] w-full h-[46px] bg-[#F6F6F6] rounded-[10px] flex  flex-row  items-center px-4 justify-between md:hidden"
                            text={link}
                            onCopy={() => setCopied(true)}
                        >
                            <div className="w-full h-full">
                                <span className="text-[#000] ">
                                    {t(copied ? "copied" : "copyLink")}
                                </span>
                                <Image
                                    // fill
                                    width={18}
                                    height={18}
                                    style={{ objectFit: "contain" }}
                                    src="/svg/link.svg"
                                    alt="link"
                                />
                            </div>
                        </CopyToClipboard>
                    </div>

                    <div className="flex flex-1  bg-[#fff] w-full justify-between py-2 md:py-0">
                        <div
                            className="flex flex-col items-center gap-1"
                            onClick={handleWhatsAppShare}
                        >
                            <div className=" cursor-pointer w-[64px] h-[64px] bg-[#F6F6F6] rounded-full flex items-center px-4 justify-center hover:bg-[#e6e6e6] transition-colors duration-200">
                                <Image
                                    // fill
                                    width={26}
                                    height={26}
                                    style={{ objectFit: "contain" }}
                                    src="/svg/whatsapp.svg"
                                    alt="whatsapp"
                                />
                            </div>
                            <span className="text-[#000] text-[13px] capitalize">
                                {t("whatsapp")}
                            </span>
                        </div>
                        <div className="flex flex-col items-center gap-1">
                            <div className=" cursor-pointer w-[64px] h-[64px] bg-[#F6F6F6] rounded-full flex items-center px-4 justify-center hover:bg-[#e6e6e6] transition-colors duration-200">
                                <Image
                                    // fill
                                    width={26}
                                    height={26}
                                    style={{ objectFit: "contain" }}
                                    src="/svg/message.svg"
                                    alt="message"
                                />
                            </div>
                            <span className="text-[#000] text-[13px] capitalize">
                                {t("message")}
                            </span>
                        </div>

                        <div
                            className="flex flex-col items-center gap-1"
                            onClick={handleXShare}
                        >
                            <div className=" relative cursor-pointer w-[64px] h-[64px] bg-[#F6F6F6] rounded-full flex items-center px-4 justify-center hover:bg-[#e6e6e6] transition-colors duration-200">
                                <Image
                                    // fill
                                    width={26}
                                    height={26}
                                    style={{ objectFit: "contain" }}
                                    src="/svg/x.svg"
                                    alt="x"
                                />
                            </div>
                            <span className="text-[#000] text-[13px] capitalize">
                                {t("twitter")}
                            </span>
                        </div>

                        {/* <div className="flex flex-col items-center gap-1">
                            <div className=" cursor-pointer w-[64px] h-[64px] bg-[#F6F6F6] rounded-full flex items-center px-4 justify-center hover:bg-[#e6e6e6] transition-colors duration-200">
                                <Image
                                    // fill
                                    width={26}
                                    height={26}
                                    style={{ objectFit: "contain" }}
                                    src="/svg/snapchat.svg"
                                    alt="snapchat"
                                />
                            </div>
                            <span className="text-[#000] text-[13px] capitalize">{t("snapchat")}</span>
                        </div> */}

                        <div className="hidden md:flex-col md:items-center gap-1 sm:hidden md:flex">
                            <CopyToClipboard
                                className="p-[0px] m-[0px] capitalize text-[13px] text-[#000] cursor-pointer w-[64px] h-[64px] focus:h-[62px] focus:w-[62px]  bg-[#F6F6F6] hover:bg-[#e6e6e6] transition-colors duration-200 rounded-full flex items-center px-4 justify-center"
                                text={link}
                                onCopy={() => setCopied(true)}
                            >
                                <div className=" cursor-pointer w-[64px] h-[64px] focus:h-[62px] focus:w-[62px]  bg-[#F6F6F6] hover:bg-[#e6e6e6] transition-colors duration-200 rounded-full flex items-center px-4 justify-center">
                                    <Image
                                        // fill
                                        width={26}
                                        height={26}
                                        style={{ objectFit: "contain" }}
                                        src="/svg/link.svg"
                                        alt="link"
                                    />
                                </div>
                            </CopyToClipboard>
                            {
                                <span className="text-[#000] text-[13px] capitalize">
                                    {t(copied ? "copied" : "copy")}
                                </span>
                            }
                        </div>
                        {/* <div className="flex flex-col items-center gap-1" onClick={handleMoreShare}>
                            <div className=" cursor-pointer w-[64px] h-[64px] bg-[#F6F6F6] rounded-full flex items-center px-4 justify-center hover:bg-[#e6e6e6] transition-colors duration-200">
                                <Image
                                    // fill
                                    width={26}
                                    height={26}
                                    style={{ objectFit: "contain" }}
                                    src="/svg/more.svg"
                                    alt="more"
                                />
                            </div>
                            <span className="text-[#000] text-[13px] capitalize">{t("more")}</span>
                        </div> */}
                    </div>
                </div>
            </div>
        </div>
    )
}

export default ShareComponent
